export const fetchWithTimeout = async (resource, options) => {
  const { timeout, ...fetchOptions } = options ?? {};

  if (typeof timeout !== "number") {
    return fetch(resource, fetchOptions);
  }

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    ...fetchOptions,
    signal: controller.signal,
  });
  clearTimeout(id);

  return response;
};
